// extracted by mini-css-extract-plugin
export default {"overlay":"CreateInviteModal_overlay__DYSN8","modal":"CreateInviteModal_modal__j4URx","title":"CreateInviteModal_title__iXneE"};